import styled, { css } from 'styled-components';

export const SideScrollStyled = styled.div<{ hideScrollBar?: boolean }>`
  ${({ hideScrollBar }) => hideScrollBar ? css`
    overflow-x: scroll;
    
    ::-webkit-scrollbar {
      display: none; // Chrome, Safari and Opera
    }

    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */

  ` : css`
    overflow-x: auto;
  `}
`;